module.exports = __webpack_public_path__ + "static/media/135U11_Kitchen.17b2e899.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U11_Kitchen.jpg
// module id = 544
// module chunks = 0